import { NewPerfectPortalCaseTypeMapping } from '@repo/ui/NewPerfectPortalCaseTypeMapping'

export default [
  {
    stageLabel: 'Create new case type',
    stageId: 'perfect-portal-case-type',
    steps: [
      {
        stepLabel: 'Case type details',
        stepDescription: 'Please enter the case type details',
        stepId: 'add-new-case-type-details',
        skippable: false,
        component: NewPerfectPortalCaseTypeMapping,
        uniqueId: 'new-perfect-portal-case-type-mapping'
      }
    ]
  }
]
